/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {Component, useEffect, useState} from 'react';
import BreadCrumb from '../../common/components/BreadCrumb';
import {Row, Col, Button, Form, FormControl} from 'react-bootstrap';

import TextHoverDisplay from "../../common/components/TextHoverDisplay";

import './InvalidateInputContainer.scss';

import {
    getInputById,
    invalidateInput
} from "./inputSlice";


import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import PanelHeader from "../../common/components/layout/PanelHeader";
import FormLabel from "../../common/components/form/FormLabel";

const InvalidateInputContainer = (props) => {
    const { id } = useParams();
    const inputState = useSelector(state => state.input);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const [breadcrumbItems, setBreadcrumbItems] = useState([]);

    const [managedInput, setManagedInput] = useState(null);

    useEffect(() => {
        dispatch(getInputById(id));
    }, [id, dispatch]);

    useEffect(() => {
        if (inputState.managedInput && inputState.managedInput.id === id) {
            setManagedInput(inputState.managedInput);
            setBreadcrumbItems(
                [
                    {label: 'Home', href: '/home', isActive: false},
                    {
                        label: 'Inputs',
                        href: '/admin/input',
                        isActive: false
                    },
                    {
                        label: `${id}`,
                        href: '',
                        isActive: true
                    },
                    {
                        label: 'Invalidate Input',
                        href: '',
                        isActive: true
                    }
                 ]
            )
        }
        }
        , [inputState.managedInput]);

    useEffect(() => {
        setAlertMessage(inputState.alertMessage);
        if (inputState.alertMessage) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }
    }, [inputState.alertMessage]);

    useEffect(() => {
        setSuccessMessage(inputState.successMessage);
        if (inputState.successMessage) {
            setShowSuccess(true);
            navigate('/admin/inputs');
        }else {
            setShowSuccess(false);
        }
    }, [inputState.successMessage]);

    const handleInvalidateInput = async () => {
        dispatch(invalidateInput({id: id}));
    };

    const handleCancel = async () => {
        navigate('/admin/inputs')
    };

    return (
        <div>
            {inputState.loading && (
                <div className="spinner-overlay">
                    <Spinner
                        as="span"
                        animation="border"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="info"
                    />
                </div>
            )}
            <Alert
                variant={"danger"}
                show={showAlert}
                onClose={() => setShowAlert(!showAlert)}
                dismissible
                transition={false}
            >
                {alertMessage}
            </Alert>
            <Alert
                variant={"success"}
                show={showSuccess}
                onClose={() => setShowSuccess(!showSuccess)}
                dismissible
                transition={false}
            >
                {successMessage}
            </Alert>
            <InvalidateInput
                id={managedInput?.id}
                name={managedInput?.name}
                handleInvalidateInput={(data) => handleInvalidateInput(data)}
                handleCancel={() => handleCancel()}
                status={managedInput?.status}
                type={managedInput?.type}
                breadcrumbItems={breadcrumbItems}
            />
        </div>
    );
};


function InvalidateInput(props) {

    const {
        breadcrumbItems,
        id,
        name,
        status,
        type,
        handleInvalidateInput,
        handleCancel,
    } = props;

    const reset = () => {

    };

    const isValid = () => {
    };

    const handleInvalidateInputClick = async () => {
        handleInvalidateInput({id});
    };

    return (
        <div className="action-input-gutter">
            <BreadCrumb items={breadcrumbItems}> </BreadCrumb>
            <PanelHeader header={`Invalidate Input - ${name ? name : ''}`} subHeader={'Invalidate the input'} />
            <div className="action-input-container">
                <div className="action-input-form-container">
                    <Form noValidate>
                        <Form.Group controlId="processInput">
                            <Row>
                                <Col md={6}>
                                    <Row>
                                        <Col md={9} className="action-input-form-label">
                                            <FormLabel>INPUT ID</FormLabel>
                                            {id &&
                                                <TextHoverDisplay
                                                    fullText={id}
                                                    truncatedText={id}
                                                    displayTruncated={false}
                                                />
                                            }

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <FormLabel>Name</FormLabel>
                                            <FormControl
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={name}
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <FormLabel>Type</FormLabel>
                                            <FormControl
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={type}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <FormLabel>Status</FormLabel>
                                            <FormControl
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={status}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="buttons">
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        variant="info"
                                        disabled={status === 'INVALIDATED' || status === 'INVALIDATING'}
                                        onClick={() => handleInvalidateInputClick()}
                                    >Invalidate
                                    </Button>
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        style={{marginLeft: "10px"}}
                                        variant="outline-secondary"
                                        onClick={() => {
                                            reset();
                                            handleCancel();
                                        }}
                                    >CANCEL
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default InvalidateInputContainer;

